export const values = {
  groupTypes: {
    private: 'Private',
    closed: 'Closed',
    public: 'Public',
  },
};
